import { CLIENT_MESSAGE, NETWORK, type AnimationState, type InputMessage } from "@mucki/shared";
import type { MovementState } from "../systems/localMovement.js";
import type { ZoneRoom } from "./stateSync.js";

export interface InputSender {
  update(delta: number, state: MovementState, animation: AnimationState): void;
}

/**
 * Uploads the locally predicted transform at a fixed rate rather than every
 * rendered frame, tagged with a monotonic sequence number so the server can
 * drop out-of-order updates.
 */
export function createInputSender(room: ZoneRoom): InputSender {
  const intervalMs = 1000 / NETWORK.inputSendRateHz;
  let sinceLastSend = 0;
  let seq = 0;

  return {
    update: (delta, state, animation) => {
      sinceLastSend += delta * 1000;
      if (sinceLastSend < intervalMs) return;
      sinceLastSend = 0;
      seq += 1;

      const message: InputMessage = {
        seq,
        x: state.x,
        y: state.y,
        z: state.z,
        rotationY: state.rotationY,
        animation,
      };
      room.send(CLIENT_MESSAGE.input, message);
    },
  };
}
